import { useRecoilValue } from "recoil";
import {
  settingsAtom,
  SettingsWithRowIds,
} from "../miscellaneous/settingsAtom";

export type UseSettingsValueData =
  | { readonly tag: "ready"; readonly data: SettingsWithRowIds }
  | {
      readonly tag: "initializing";
      readonly data: Partial<SettingsWithRowIds>;
    };

const settingsLoading: SettingsWithRowIds = {} as const;

export function useSettingsValueData(): UseSettingsValueData {
  const settingsValue = useRecoilValue(settingsAtom);

  return settingsValue === "initializing"
    ? {
        tag: "initializing",
        data: settingsLoading,
      }
    : {
        tag: "ready",
        data: settingsValue,
      };
}
